import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { B2BBankTransferPaymentTileModel } from '@/types/B2BcontentServerContract';
import CheckoutPaymentBankTransfer from '@/b2b/checkout/ui/payment/CheckoutPaymentBankTransfer.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'B2BBankTransferPaymentTile',
  props: {
    content: null
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CheckoutPaymentBankTransfer))
}
}

})